import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';

import * as _ from 'lodash';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { CircularsService } from 'src/app/modules/retailer/services/circulars.service';

@Component({
  selector: 'app-circular-list',
  templateUrl: './circular-list.component.html',
  styleUrls: ['./circular-list.component.scss']
})
export class CircularListComponent implements OnInit {

  public loginData: any;

  public stores: any = [];
  public storesLoading: boolean = false;
  public selectedStore: any = 0;

  public circulars: any = [];
  public circularsPage: number = 1;
  public circularsCount: number = 0;
  public circularsLoading: boolean = false;

  public circularPreviewData: any; // Circular data for preview
  public circularPreviewModal: BsModalRef;

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _circularsService: CircularsService,
    private _modalService: BsModalService,
  ) { }

  ngOnInit(): void {
    this.getStorageData();
  }

  async getStorageData() {
    this.loginData = await this._utilService.getStorageData('R_LOGIN');

    this.getStores();
  }

  // Get stores
  getStores() {
    this.stores = [];
    this.storesLoading = true;

    let getStoresBody = {
      provider_type: this.loginData.user_details.provider_type,
      provider_id: this.loginData.user_details.provider_id,
      circular_count: true
    };

    this._circularsService.getStores(this.loginData.token, getStoresBody).subscribe(async getStoresResponse => {
      this.storesLoading = false;

      if (getStoresResponse.status === true) { // Success
        if (getStoresResponse.retailers.length == 1) {
          this.stores = getStoresResponse.retailers[0].stores;

          this.selectedStore = getStoresResponse.retailers[0].stores[0].store_id; // Set first store as default

          this.circularsPage = 1;
          this.getCirculars();
        }
      } else {
        this._utilService.showToast(getStoresResponse.message, '', 'error', {});
      }
    }, error => { // Error from getStores
      this.storesLoading = false;
    });
  }

  // Store change
  onStoreChange(event: any) {
    this.circularsPage = 1;
    this.getCirculars();
  }

  // Get circulars
  getCirculars() {
    this.circulars = [];
    this.circularsCount = 0;
    this.circularsLoading = true;

    this._circularsService.getCirculars(this.loginData.token, this.loginData.user_details.provider_id, this.selectedStore, this.circularsPage).subscribe(async getCircularsResponse => {
      this.circularsLoading = false;

      if (getCircularsResponse.status === true) { // Success
        this.circulars = getCircularsResponse.circulars;
        this.circularsCount = getCircularsResponse.total_count;
      } else {
        this._utilService.showToast(getCircularsResponse.message, '', 'error', {});
      }
    }, error => { // Error from getCirculars
      this.circularsLoading = false;
    });
  }

  // Circulars page change
  onCircularsPageChange(event: any) {
    this.circularsPage = event;
    this.getCirculars();
  }

  // On edit circular
  onEditCircular(circular: any) {
    this._router.navigate(['/retailer/manage-circular'], {
      state: { store_id: this.selectedStore, circular: circular }
    });
  }

  // Show circular preview modal
  async showCircularPreviewModal(circular: any, template: TemplateRef<any>) {
    this.circularPreviewData = circular;
    this.circularPreviewModal = this._modalService.show(template, {class: 'modal-sm'});
  }

  // Hide circular preview modal
  hideCircularPreviewModal(): void {
    this.circularPreviewModal.hide();
  }

}
